import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=c59343dc"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports